
.content {
    display: flex;
    padding: 0;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    flex: 1 0 0;
}

.container {
    display: flex;
    padding: 1rem;
    align-items: flex-start;
    gap: 0.75rem;
    max-width: 100%;
  
    border-radius: 12px;
    
    &.success {
      background: var(--sentiment-background-positive, rgba(70, 181, 96, 0.12));
  
      svg {
        color: var(--sentiment-text-positive, #46b560);
      }
    }
  
    &.error {
      background: var(--sentiment-background-negative, rgba(218, 37, 45, 0.08));
  
      svg {
        color: var(--sentiment-text-negative, #da3109);
      }
    }
  
    &.info {
      background: var(--sentiment-background-info, rgba(37, 103, 234, 0.08));
      color: var(--static-text-strong);
    }
  
    &.warning {
      background: var(--sentiment-background-notice, rgba(241, 202, 47, 0.16));
  
      svg {
        color: var(--sentiment-text-notice, #f1ca2f);
      }
    }
  
    &.fullWidth {
      width: 100%;
    }
}